module.exports = __webpack_public_path__ + "fonts/ae3232c.otf";